// extracted by mini-css-extract-plugin
export default {"imgdiv":"d177a64151 e23bf5ab4f","img":"_4c641d575c _3453061d96"};